// ** MUI Imports
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// ** Icon Imports
// import Icon from 'src/@core/components/icon'

// ** Custom Components Imports
// import CustomTextField from 'src/@core/components/mui/text-field'
// import DeletePopUpModel from './DeletePopupModel'

// import { useForm, Controller } from 'react-hook-form'
import { Autocomplete, Chip, Grid, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
// import CustomAutocomplete from 'src/@core/components/mui/autocomplete'
// import { updateAssignUser } from 'src/store/apps/query-category'
import { useEffect, useState } from 'react'
import axios from 'axios'

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(6),
  justifyContent: 'space-between'
}))

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

const EditModal = ({ toggle, popupData }) => {

  const [deleteOpen, setDeleteOpen] = useState(false)
  const [first, setfirst] = useState([])
  const [second, setsecond] = useState([])
  const [third, setthird] = useState([])

  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleDeleteChip = (chipToDelete) => () => {
    setChips((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const handleAddChip = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setChips([...chips, inputValue.trim()]);
      setInputValue('');
    }
  };


useEffect(() => {

    popupData.emailist.map((d)=>{
        if (d.
            level==="LEVEL1"
            ) {
                setfirst(d.email)
        }
        else if(d.level==="LEVEL2"){
              setsecond(d.email)
        }
        else if(d.level==="LEVEL3"){
               setthird(d.email)
        }
    })
    console.log(popupData);
    const subCategoryArray = popupData.SUB_CATEGORY
    .split(',').map(item => item.trim());
    setChips(subCategoryArray)
}, [])



  const dispatch = useDispatch()
  const handleChangeLevel1=(event)=>{
    const {
        target: { value },
      } = event;
      setfirst(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
  }

  const handleChangeLevel2=(event)=>{
    const {
        target: { value },
      } = event;
      setsecond(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
  }

  const handleChangeLevel3=(event)=>{
    const {
        target: { value },
      } = event;
      setthird(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
  }

  const handleDelete = i => {
    let newArray = subcategory.filter((_, index) => index !== i)
    setSubcategory(newArray)
  }

  const patchData = async (datatopatch) => {
    try {
        const token = localStorage.getItem('token');

      const response = await axios.patch( 'http://localhost:8028/api/v1/query/updateStatus', datatopatch,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json', // Adjust content type if necessary
        },
      });
      console.log('Response:', response.data);
 return;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  };
  

  const update = e => {
    const arrayOfObjects = chips.map(value => ({ name: value }));

    const datatopatch={
        changeStatus:false,
        id:popupData._id,
        subCategory:arrayOfObjects,
        category:popupData.CATEGORY


    }
    console.log('patchdata',datatopatch);
    patchData(datatopatch)
    
  }

  return (
    <Box>
      <Header>
        <Typography variant='h5'>Category Details</Typography>
        <IconButton
          size='small'
          onClick={toggle}
          sx={{
            p: '0.375rem',
            borderRadius: 1,
            color: 'text.primary',
            '&:hover': {
             // backgroundColor: theme => `rgba(${theme.palette.customColors.main}, 0.16)`
            }
          }}
        >
          {/* <Icon icon='tabler:x' fontSize='1.25rem' /> */}
        </IconButton>
      </Header>
      <form >
        <Box sx={{ p: theme => theme.spacing(0, 6, 6) }}>
          <Grid container rowGap={4} columnGap={5}>
            <Grid item xs={12} sm={6}>
            <Grid item>
                <Typography variant="body1">Category</Typography>
                <TextField
                  InputProps={{ sx: { height: 50 } }}
                  value={popupData.CATEGORY}
                  disabled
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
            <Grid item>
                <Typography variant="body1">Sub-Category</Typography>
                <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={chips}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onKeyDown={handleAddChip}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option}
            {...getTagProps({ index })}
            onDelete={handleDeleteChip(option)}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Enter values"
          placeholder="Press enter to add"
        />
      )}
    />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant='subtitle1'>Levels and Roles</Typography>
            </Grid>
            <Grid item xs='auto' sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center',width:'100%' }}>
            <Box sx={{ flex: '0 0 200px', minWidth: '200px' }}>
            <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={first}
          sx={{width:200,minHeight:50}}

          onChange={handleChangeLevel1}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:180,minHeight:50}}             // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
        </Box>

        <Box sx={{ flex: '0 0 200px', minWidth: '230px',ml:4 }}>

        <Typography variant='body2' sx={{ fontStyle: 'italic'}}>
                Ticket assigned immediately
              </Typography>
              </Box>
              </Box>
            </Grid>
            
            <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center',width:'100%' }}>
            <Box sx={{ flex: '0 0 200px', minWidth: '200px' }}>
            <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={second}
          sx={{width:200,minHeight:50}}
          onChange={handleChangeLevel2}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:180,minHeight:50}}
               // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
        </Box>
        <Box sx={{ flex: '0 0 200px', minWidth: '230px' }}>

        <Typography variant='body2' sx={{ fontStyle: 'italic', mt: 4,ml:4 }}>
                Escalated after 1 hour of ticket creation
              </Typography>
              </Box>
              </Box>
            </Grid>
           
            <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', alignItems: 'center',width:'100%' }}>
                <Box sx={{ flex: '0 0 200px', minWidth: '200px' }}>
            <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={third}
          sx={{width:'100%',minHeight:50}}
          onChange={handleChangeLevel3}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:180,minHeight:50}}
               // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
        </Box>
        <Box sx={{ flex: '0 0 200px', minWidth: '200px' }}>

        <Typography variant='body2' sx={{ fontStyle: 'italic', mt: 4,ml:4 }}>
                Escalated after 3 hours of ticket creation
              </Typography>
              </Box>
              </Box>
            </Grid>
          
            <Grid container columnGap={4} marginTop={4}>
           
              <Button variant='tonal' color='secondary' sx={{mr:3,backgroundColor:'#778899',color:'white' ,'&:hover': {
          backgroundColor: '#778899', 
        }}} onClick={toggle}>
                Cancel
              </Button>
              <Button variant='contained'  onClick={update}>
                Update
              </Button>
            </Grid>
            <Box>
              <Typography variant='subtitle2'>Please Note:</Typography>
              <Typography variant='subtitle2'>
                Ticket will be automatically marked Unresolved after 24 hours If no action has been taken by all
                users/levels
              </Typography>
            </Box>
          </Grid>
        </Box>
      </form>
      {/* <DeletePopUpModel deleteOpen={deleteOpen} setDeleteOpen={setDeleteOpen} category={data} onClose={toggle} /> */}
    </Box>
  )
}

export default EditModal
